import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { MoleculeModule } from '../molecule/molecule.module'
import { AccountComponent } from './account/account.component'
import { AchievementsComponent } from './achievements/achievements.component'
import { ChangePhoneComponent } from './change-phone/change-phone.component'
import { CheckoutComponent } from './checkout/checkout.component'
import { DashboardComponent } from './dashboard/dashboard.component'
import { DesignSystemComponent } from './design-system/design-system.component'
import { HomeComponent } from './home/home.component'
import { LoginComponent } from './login/login.component'
import { NotFoundAlphaComponent } from './not-found-alpha/not-found-alpha.component'
import { PaymentComponent } from './payment/payment.component'
import { ProductDetailsComponent } from './product-details/product-details.component'
import { RegisterCompleteComponent } from './register-complete/register-complete.component'
import { RegisterComponent } from './register/register.component'
import { SettingsComponent } from './settings/settings.component'
import { VerifyComponent } from './verify/verify.component'
import { EmailVerifyComponent } from './email-verify/email-verify.component'

@NgModule({
  declarations: [],
  imports: [
    MoleculeModule,
    RegisterCompleteComponent,
    RegisterComponent,
    SettingsComponent,
    VerifyComponent,
    EmailVerifyComponent,
    AchievementsComponent,
    DashboardComponent,
    AccountComponent,
    ChangePhoneComponent,
    PaymentComponent,
    ProductDetailsComponent,
    CheckoutComponent,
    LoginComponent,
    HomeComponent,
    DesignSystemComponent,
    NotFoundAlphaComponent,
  ],
  providers: [],
  exports: [MoleculeModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrganismModule {}
